// Do not edit.
import { ShaderStore } from "core/Engines/shaderStore";

const name = "multiScatteringPixelShader";
const shader = `#define RENDER_MULTI_SCATTERING
#define COMPUTE_MULTI_SCATTERING
precision highp float;
#include<__decl__atmosphereFragment>
uniform sampler2D transmittanceLut;
#include<helperFunctions>
#include<atmosphereFunctions>
varying vec2 uv;void main() {gl_FragColor=renderMultiScattering(uv,transmittanceLut);}`;
// Sideeffect
if (!ShaderStore.ShadersStore[name]) {
    ShaderStore.ShadersStore[name] = shader;
}
ShaderStore._PendingIncludesLoaders.push(() => Promise.all([
    import("../Shaders/ShadersInclude/atmosphereFragmentDeclaration"),
    import("../Shaders/ShadersInclude/atmosphereUboDeclaration"),
    import("core/Shaders/ShadersInclude/helperFunctions"),
    import("../Shaders/ShadersInclude/atmosphereFunctions")
]));
/** @internal */
export const multiScatteringPixelShader = { name, shader };
